import { render } from "./PhotoGalleryCard.vue?vue&type=template&id=3ceffdb8"
import script from "./PhotoGalleryCard.vue?vue&type=script&lang=js"
export * from "./PhotoGalleryCard.vue?vue&type=script&lang=js"

import "./PhotoGalleryCard.vue?vue&type=style&index=0&id=3ceffdb8&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\projects\\external\\kazigraphix\\admin.kazigraphix\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__